// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hpsl-wrapper {
    text-decoration: none;
    color: inherit;
}
.hpsl-wrapper:hover {
    text-decoration: none;
    color: inherit;
}
.hpsl-outline-provider {
    padding: 9px;
    background-color: #fff;
    border-radius: min(1vw, 5px);
    height: 100%;
    box-sizing: border-box;
    transition: transform 0.2s;
}
.hpsl-outline-provider:hover {
    transform: scale(1.02);
}

.hpsl-container {
    border-radius: min(1vw, 5px);
    border-width: 2px;
    border-style: solid;
    position: relative;
    padding: 8px 15px;
    display: flex;
    column-gap: 10px;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
}

.hpsl-title {
    position: absolute;
    -webkit-user-select: none;
            user-select: none;
    top: -7px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: #fff;
    line-height: 1;
    text-align: center;
    width: -moz-fit-content;
    width: fit-content;
    padding: 0 5px;
    font-family: var(--displayFont);
    font-size: 14px;
    font-weight: 700;
}
.hpsl-image {
    height: 30px;
    margin: auto;
}
.hpsl-desc {
    font-family: var(--displayFont);
    font-size: 24px;
    font-weight: 700;
    padding: 0;
    margin: 0;
}

/* Small Desktop */
@media screen and (max-width: 1100px) and (max-height: 1300px) {
    .hpsl-wrapper {
        border-radius: 8px !important;
        font-size: 0;
        background-color: #fff !important;
        margin: 0;
    }
    .hpsl-image {
        height: 20px !important;
    }
    .hpsl-desc {
        font-size: 18px;
    }
    .hpsl-outline-provider {
        padding: 8px !important;
    }
    .hpsl-title {
        font-size: 10px !important;
        top: -5px !important;
    }
}

/* Tiny Desktop */
@media screen and (max-width: 700px) and (max-height: 800px) {
    .hpsl-title {
        font-size: 7px !important;
        top: -4px !important;
    }
    .hpsl-outline-provider {
        padding: 6px !important;
    }
    .hpsl-image {
        height: 18px !important;
    }
    .hpsl-desc {
        font-size: 16px !important;
    }
    .htc-lookbelow {
        display: none; /* There's literally just no space for this */
    }
}

/* Tablets (height slightly larger than width) */
@media screen and (max-width: 1100px) and (min-height: 1300px) {
    .hpsl-title {
        font-size: 14px !important;
        top: -6px !important;
    }
    .hpsl-outline-provider {
        padding: 12px !important;
    }
    .hpsl-image {
        height: 26px !important;
    }
    .hpsl-desc {
        font-size: 28px !important;
    }
}

/* Tiny Mobile */
@media screen and (max-width: 400px) and (max-height: 800px) {
    .hpsl-container {
        padding: 6px 9px;
    }
    .hpsl-wrapper {
        border-radius: 4px !important;
    }
    .hpsl-outline-provider {
        padding: 6px !important;
    }
    .hpsl-title {
        font-size: 8px !important;
        top: -3px !important;
    }
    .hpsl-image {
        height: 20px !important;
    }
    .hpsl-desc {
        font-size: 14px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/home/HomepageSitelink.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI;QACI,6BAA6B;QAC7B,YAAY;QACZ,iCAAiC;QACjC,SAAS;IACb;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;AACJ;;AAEA,iBAAiB;AACjB;IACI;QACI,yBAAyB;QACzB,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa,EAAE,6CAA6C;IAChE;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,gBAAgB;IACpB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;QACzB,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".hpsl-wrapper {\n    text-decoration: none;\n    color: inherit;\n}\n.hpsl-wrapper:hover {\n    text-decoration: none;\n    color: inherit;\n}\n.hpsl-outline-provider {\n    padding: 9px;\n    background-color: #fff;\n    border-radius: min(1vw, 5px);\n    height: 100%;\n    box-sizing: border-box;\n    transition: transform 0.2s;\n}\n.hpsl-outline-provider:hover {\n    transform: scale(1.02);\n}\n\n.hpsl-container {\n    border-radius: min(1vw, 5px);\n    border-width: 2px;\n    border-style: solid;\n    position: relative;\n    padding: 8px 15px;\n    display: flex;\n    column-gap: 10px;\n    align-items: center;\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.hpsl-title {\n    position: absolute;\n    user-select: none;\n    top: -7px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    background-color: #fff;\n    line-height: 1;\n    text-align: center;\n    width: fit-content;\n    padding: 0 5px;\n    font-family: var(--displayFont);\n    font-size: 14px;\n    font-weight: 700;\n}\n.hpsl-image {\n    height: 30px;\n    margin: auto;\n}\n.hpsl-desc {\n    font-family: var(--displayFont);\n    font-size: 24px;\n    font-weight: 700;\n    padding: 0;\n    margin: 0;\n}\n\n/* Small Desktop */\n@media screen and (max-width: 1100px) and (max-height: 1300px) {\n    .hpsl-wrapper {\n        border-radius: 8px !important;\n        font-size: 0;\n        background-color: #fff !important;\n        margin: 0;\n    }\n    .hpsl-image {\n        height: 20px !important;\n    }\n    .hpsl-desc {\n        font-size: 18px;\n    }\n    .hpsl-outline-provider {\n        padding: 8px !important;\n    }\n    .hpsl-title {\n        font-size: 10px !important;\n        top: -5px !important;\n    }\n}\n\n/* Tiny Desktop */\n@media screen and (max-width: 700px) and (max-height: 800px) {\n    .hpsl-title {\n        font-size: 7px !important;\n        top: -4px !important;\n    }\n    .hpsl-outline-provider {\n        padding: 6px !important;\n    }\n    .hpsl-image {\n        height: 18px !important;\n    }\n    .hpsl-desc {\n        font-size: 16px !important;\n    }\n    .htc-lookbelow {\n        display: none; /* There's literally just no space for this */\n    }\n}\n\n/* Tablets (height slightly larger than width) */\n@media screen and (max-width: 1100px) and (min-height: 1300px) {\n    .hpsl-title {\n        font-size: 14px !important;\n        top: -6px !important;\n    }\n    .hpsl-outline-provider {\n        padding: 12px !important;\n    }\n    .hpsl-image {\n        height: 26px !important;\n    }\n    .hpsl-desc {\n        font-size: 28px !important;\n    }\n}\n\n/* Tiny Mobile */\n@media screen and (max-width: 400px) and (max-height: 800px) {\n    .hpsl-container {\n        padding: 6px 9px;\n    }\n    .hpsl-wrapper {\n        border-radius: 4px !important;\n    }\n    .hpsl-outline-provider {\n        padding: 6px !important;\n    }\n    .hpsl-title {\n        font-size: 8px !important;\n        top: -3px !important;\n    }\n    .hpsl-image {\n        height: 20px !important;\n    }\n    .hpsl-desc {\n        font-size: 14px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
